// extracted by mini-css-extract-plugin
export default {"time_firstdiv_right_data_right_button":"Counter_time_firstdiv_right_data_right_button__5d373","clock":"Counter_clock__w4-ex","spin":"Counter_spin__rIi4G"};